import IconDesktop from "assets/img/icon-desktop.svg?react"
import IconMobile from "assets/img/icon-mobile.svg?react"

import { FC, useMemo } from "react"
import { useTranslation } from "react-i18next"

import { OperationHoursSource } from "models/OperationHoursRecord"
import { Flex, FlexItem } from "components/Flex"
import FlexibleContent from "components/FlexibleContent/FlexibleContent"
import { Guid } from "@/types"
import reservationSidebars from "stores/reservationSidebars"
import Text from "components/Text/Text"

interface IOperationHoursRecordTypeProps {
    source: OperationHoursSource
    reservationId?: Guid
    reservationNumber?: string
}

const OperationHoursRecordType: FC<IOperationHoursRecordTypeProps> = ({
    source,
    reservationId,
    reservationNumber,
}) => {
    const { t } = useTranslation()

    const icon = useMemo(() => {
        switch(source) {
            case OperationHoursSource.manual:
                return <IconDesktop className="d-block" width={24} height={24} />
            case OperationHoursSource.inspection:
            case OperationHoursSource.condition:
                return <IconMobile className="d-block" width={24} height={24} />
            default:
                return null
        }
    }, [source])

    const label = useMemo(() => {
        switch(source) {
            case OperationHoursSource.manual:
                return t('operationHoursSource.manual')
            case OperationHoursSource.inspection:
                return t('operationHoursSource.inspection')
            case OperationHoursSource.condition:
                return t('operationHoursSource.condition')
            default:
                return null
        }
    }, [source, t])

    return (
        <>
            {!!icon && !!label &&
                <Flex alignItems="center" gap="1rem" className="color-grey-500">
                    {!!icon &&
                        <FlexItem shrink={0}>
                            {icon}
                        </FlexItem>
                    }
                    {!!label &&
                        <FlexibleContent text={label} />
                    }
                </Flex>
            }
            {!!reservationNumber &&
                <Text type="pSmallest">
                    <div style={{ paddingLeft: "3.4rem" }}>
                        <FlexibleContent
                            text={reservationNumber}
                            onClick={reservationId
                                ? () => reservationSidebars.show({ reservationId })
                                : undefined
                            }
                        />
                    </div>
                </Text>
            }
        </>
    )
}

export default OperationHoursRecordType
